import { IConfigurationValuesService } from '@services/ConfigurationValuesService';
import { createConfigurationValuesService } from '@services/factories';
import { ExternalLink } from '@styles/shared-styles';
import * as React from 'react';

class USCISFormI9Section2Link extends React.PureComponent {
    // Probably good idea to dependency inject these later
    configurationValuesService: IConfigurationValuesService = createConfigurationValuesService();

    render() {
        return (
            <ExternalLink href={this.configurationValuesService.uscisSection2FormI9Url}
                          target='_blank'>
                {this.configurationValuesService.uscisSection2FormI9UrlText}
            </ExternalLink>
        );
    }
}

export default USCISFormI9Section2Link;



// WEBPACK FOOTER //
// ./src/containers/links/uscis-formI9-section2-link.tsx